var error = {
  translation: {
    error: {
      coreNotFound: "Asosiy sozlamalarni yuklab bo'lmadi",
      domainNotAllowed: "Bu domenli email bilan ro'yxatdan o'ta olmaysiz",
      emailAlreadyInUse: 'Bu email allaqachon ishlatilmoqda',
      insufficientPermissions: "Yetarli ruxsat yo'q",
      invalidCurrentPassword: "Joriy parol noto'g'ri",
      invalidPermissions: 'Kamida bitta ruxsatni tanlang',
      invalidUsernameOrPassword: "Notog'ri foydalanuvchi nomi yoki parol",
      localRegistrationDisabled: "Mahalliy ro'yxatdan o'tish administrator tomonidan o'chirilgan",
      noInternetConnection: "Internet aloqasi yo'q",
      noOidcProfileFound: 'OIDC profil topilmadi',
      policyNotAccepted: 'Iltimos, Xizmat shartlari va Maxfiylik siyosatini qabul qiling',
      registrationDisabled: "Foydalanuvchi ro'yxatdan o'tishi administrator tomonidan o'chirilgan",
      serverConnectionFailed: 'Serverga ulanish muvaffaqiyatsiz',
      ssoRegistrationDisabled: "SSO ro'yxatdan o'tish administrator tomonidan o'chirilgan",
      tooManyFailedAttempts: "Juda ko'p muvaffaqiyatsiz urinishlar - keyinroq qayta urinib ko'ring",
      unknownError: "Noma'lum xato, keyinroq qayta urinib ko'ring",
      usernameAlreadyInUse: 'Bu foydalanuvchi nomi allaqachon band',
      weakPassword: 'Iltimos kuchliroq parol ishlating',
    },
  },
};

export { error as default };
